import translations from "./translations";
import { useAuth } from "../contexts/AuthContext";

export function useTranslation() {
  const { language } = useAuth();

  const t = (key) => {
    const entry = translations[key];

    if (!entry) return key;

    return entry[language] || entry["df"];
  };

  return { t, language };
}